import { useQuery } from "react-query";
import { PortfolioApi, WhatIfComparisonApi } from "@iliotech/generated-api-v3";
import { API_BASE } from "../../constants/constants";

export const usePortfolioComparison = (
  externalAccountId: string,
  portfolioId: string,
  otherPortfolioId: string,
  dateFrom?: string
) => {
  const api = new WhatIfComparisonApi(undefined, `${API_BASE}/api`);
  return useQuery(
    [`portfolio-comparison`, { portfolioId, otherPortfolioId, dateFrom }],
    () =>
      api.getPortfolioComparison(
        externalAccountId,
        portfolioId,
        otherPortfolioId,
        dateFrom
      ),
    {
      enabled: !!portfolioId && !!otherPortfolioId && !!dateFrom,
    }
  );
};
